import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MatDialog } from '@angular/material/dialog';
import { SimpleDialogComponent } from '../simple-dialog/simple-dialog.component';
import { L10nTranslationService } from 'angular-l10n';
import { ISimpleDialog } from '../simple-dialog/simple-dialog.interface';

@Injectable()
export class HandleUnrecoverableStateService {
  private updates = inject(SwUpdate);
  dialog = inject(MatDialog);
  translation = inject(L10nTranslationService);

  constructor() {
    this.checkUnrecoverableState();
  }

  checkUnrecoverableState(): void {
    this.updates.unrecoverable.subscribe((event) =>
      this.showConfirmDialog(
        'An error occurred that we cannot recover from:\n' +
          event.reason +
          '\n\nPlease reload the page.'
      )
    );
  }

  showConfirmDialog(text: string): void {
    const data: ISimpleDialog = {
      body: this.translation.translate(text) as string,
    };
    this.dialog.open(SimpleDialogComponent, { data });
  }
}
